import nav from './nav'
import hero from './hero'

const header = (state) => `<header>
<div class="wrapper h-100 overflow-hidden position-relateve">
    <div class="row justify-content-end pt-3 ">
        <i class='icon-menu pointer'><svg xmlns="http://www.w3.org/2000/svg" width="23.136" height="15.424" viewBox="0 0 23.136 15.424"><path d="M6.427,25.707H29.563V23.136H6.427v2.571Zm0-6.427H29.563V16.71H6.427V19.28Zm0-9v2.571H29.563V10.283H6.427Z" transform="translate(-6.427 -10.283)" fill="#fff"/></svg></i>
        <i class='icon-close pointer'>
            <svg xmlns="http://www.w3.org/2000/svg" width="23.426" height="15.423" viewBox="0 0 13.426 13.423">
                <path id="Icon_ionic-ios-close" data-name="Icon ionic-ios-close" d="M19.589,18l4.8-4.8A1.124,1.124,0,0,0,22.8,11.616l-4.8,4.8-4.8-4.8A1.124,1.124,0,1,0,11.616,13.2l4.8,4.8-4.8,4.8A1.124,1.124,0,0,0,13.2,24.384l4.8-4.8,4.8,4.8A1.124,1.124,0,1,0,24.384,22.8Z" transform="translate(-11.285 -11.289)" fill="#fff"/>
            </svg>
        </i>
        </div>
    <!-- Nav -->
    ${nav(state)}
    
    <!-- Hero  -->
    ${hero(state)}
</div>
</header>`

export default header
